import { ControlValueAccessor, FormGroup, FormGroupDirective } from '@angular/forms';
import { Input } from '@angular/core';

export abstract class HappyInputBase implements ControlValueAccessor {

    private static id = 1;
    id: string;

    @Input() formControlName: string;
    @Input() required = true;

    form: FormGroup;

    constructor(protected parentForm: FormGroupDirective) {
        this.id = 'happy_' + HappyInputBase.id++;
    }

    ngOnInit() {
        this.form = this.parentForm.form;
    }

    abstract writeValue(obj: any): void

    abstract registerOnChange(fn: any): void

    abstract registerOnTouched(fn: any)

    abstract setDisabledState(isDisabled: boolean)
}



// WEBPACK FOOTER //
// ./src/app/shared/components/happy/happy-template-input/happy-input-base.ts